import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import api from './utils/api'
Vue.mixin({
  data() {
      return {
          base_url: 'https://triplefireman.com/',
          base_media_url : 'https://triplefireman.com/media/'
      }
  }
})
Vue.prototype.$api = api
Vue.config.productionTip = false
Vue.use(ElementUI)

new Vue({
  router,
  store,
  api,
  render: h => h(App)
}).$mount('#app')

